import { render, staticRenderFns } from "./charger-salary.vue?vue&type=template&id=30bf1d05&scoped=true&"
import script from "./charger-salary.vue?vue&type=script&lang=js&"
export * from "./charger-salary.vue?vue&type=script&lang=js&"
import style0 from "./charger-salary.vue?vue&type=style&index=0&id=30bf1d05&scoped=true&lang=css&"
import style1 from "./charger-salary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf1d05",
  null
  
)

export default component.exports